import { Button } from "@mui/material";
import { useNavigate } from "react-router";

import { ViewWrapper } from "..";

import Image from "@/assets/svgs/error-404.svg";

export function Error404() {
  const navigate = useNavigate();

  return (
    <ViewWrapper
      title="404: Something's wrong here..."
      subtitle="We can't find the resource you're looking for."
      image={Image}
      action={
        <Button variant="outlined" color="primary" onClick={() => navigate("/")}>
          Back to Home
        </Button>
      }
    />
  );
}
